<!--<ng-container *ngIf="useWC; then webComponents; else legacyComponents"></ng-container>-->

<!--<ng-template #webComponents>-->
<!--  &lt;!&ndash;-->
<!--    <ids-layout-grid auto-fit="true" align-items="center">-->
<!--      <ids-layout-grid-cell>-->
<!--  &ndash;&gt;-->
<!--  &lt;!&ndash;id="{{testVersion1 ? listSpec.busListSpec.id + '_pager' : null}}"&ndash;&gt;-->
<!--  &lt;!&ndash;<ids-pager #IdsPager attr.id="{{pagerId}}" page-size="{{pageSize}}" class="lm-wc-card-list-pager-border">&ndash;&gt;-->
<!--  &lt;!&ndash;[class.lm-wc-card-list-pager-border]="cardListOnLeft">&ndash;&gt;-->
<!--  <ids-pager #IdsPager attr.id="{{pagerId}}" page-size="{{pageSize}}">-->
<!--    <ids-pager-button first [attr.disabled]="!enableFirstButton" [tooltip]="firstPageTooltip" (click)="onFirstPage($event)"></ids-pager-button>-->
<!--    <ids-pager-button previous [attr.disabled]="!enablePreviousButton" [tooltip]="previousPageTooltip" (click)="onPreviousPage($event)"></ids-pager-button>-->
<!--    <ids-pager-button next [attr.disabled]="!enableNextButton" [tooltip]="nextPageTooltip" (click)="onNextPage($event)"></ids-pager-button>-->
<!--    <ids-pager-button last [attr.disabled]="!enableLastButton" [tooltip]="lastPageTooltip" (click)="onLastPage($event)"></ids-pager-button>-->
<!--    <ids-pager-dropdown #IdsPagerDropdown *ngIf="showPageSizeSelector" slot="end" label=""></ids-pager-dropdown>-->
<!--    &lt;!&ndash;-->
<!--            <ids-pager-dropdown #IdsPagerDropdown slot="end" label=""></ids-pager-dropdown>-->
<!--    &ndash;&gt;-->
<!--  </ids-pager>-->
<!--  &lt;!&ndash;-->
<!--      </ids-layout-grid-cell>-->
<!--    </ids-layout-grid>-->
<!--  &ndash;&gt;-->
<!--</ng-template>-->

<!--<ng-template #legacyComponents>-->
  <!--
    id="{{testVersion1 ? listSpec.busListSpec.id + '_pager' : null}}"
    [attr.data-automation-id]="pagerAutomationId"
    [attributes]="pagerIdAttributes"
  -->
  <div soho-standalone-pager
       attr.id="{{pagerId ? pagerId : null}}"
       [attr.data-automation-id]="automationId"
       [attributes]="attributes"
       [smallPageSizeSelector]="true"
       [pageSizeMenuSettings]="{ attachToBody: true }"
       [showPageSizeSelector]="showPageSizeSelector"

       [enableFirstButton]="enableFirstButton"
       [enablePreviousButton]="enablePreviousButton"
       [enableNextButton]="enableNextButton"
       [enableLastButton]="enableLastButton"

       [firstPageTooltip]="firstPageTooltip"
       [previousPageTooltip]="previousPageTooltip"
       [nextPageTooltip]="nextPageTooltip"
       [lastPageTooltip]="lastPageTooltip"

       [pageSize]="pageSize"
       [pageSizes]="pageSizes"

       (firstPage)="onFirstPage($event)"
       (previousPage)="onPreviousPage($event)"
       (nextPage)="onNextPage($event)"
       (lastPage)="onLastPage($event)"
       (pageSizeChange)="onPageSizeChange($event)"
  ></div>
<!--</ng-template>-->

